export const PREMIER_LEAGUE_TEAMS = [
  { id: '133604', name: 'Arsenal', shortName: 'Arsenal' },
  { id: '133612', name: 'Aston Villa', shortName: 'Aston Villa' },
  { id: '133615', name: 'Bournemouth', shortName: 'Bournemouth' },
  { id: '135937', name: 'Brentford', shortName: 'Brentford' },
  { id: '133626', name: 'Brighton', shortName: 'Brighton' },
  { id: '133610', name: 'Chelsea', shortName: 'Chelsea' },
  { id: '133609', name: 'Crystal Palace', shortName: 'Crystal Palace' },
  { id: '133614', name: 'Everton', shortName: 'Everton' },
  { id: '133619', name: 'Fulham', shortName: 'Fulham' },
  { id: '135943', name: 'Ipswich Town', shortName: 'Ipswich' },
  { id: '133631', name: 'Leicester City', shortName: 'Leicester' },
  { id: '133602', name: 'Liverpool', shortName: 'Liverpool' },
  { id: '133613', name: 'Manchester City', shortName: 'Man City' },
  { id: '133611', name: 'Manchester United', shortName: 'Man Utd' },
  { id: '134777', name: 'Newcastle United', shortName: 'Newcastle' },
  { id: '133616', name: 'Nottingham Forest', shortName: 'Nottm Forest' },
  { id: '133618', name: 'Southampton', shortName: 'Southampton' },
  { id: '133625', name: 'Tottenham', shortName: 'Tottenham' },
  { id: '133623', name: 'West Ham', shortName: 'West Ham' },
  { id: '133629', name: 'Wolves', shortName: 'Wolves' }
];

export const DEFAULT_TEAM = '133604'; // Arsenal
